<div class="data-sect">
    <h3 *ngIf="type">{{ type }} Thumbnail List</h3>
    <hr>
    <mat-accordion *ngIf="data && data.length > 0">
        <mat-expansion-panel
            *ngFor="let item of data"
            class="margin-bottom-20"
            (opened)="panelMap[item?.id] = true"
            (closed)="panelMap[item?.id] = false"
            [expanded]="panelMap[item?.id]"
        >
            <mat-expansion-panel-header class="mat-expansion-panel-header--auto">
                <div class="list-item width-stretch">
                    <div class="list-item-content">
                        <h4 class="margin-bottom-10">{{ item.title }}</h4>
                    </div>
                </div>
            </mat-expansion-panel-header>
            <a [href]="item.thumbnailImage" target="_blank" *ngIf="item.thumbnailImage"> View Thumbnail Image</a>
        </mat-expansion-panel>
    </mat-accordion>
    <div *ngIf="data?.length === 0 && type">
        <p class="no-data">No data found</p>
    </div>
</div>
